export { default } from './WireConfirmationBadge';
